import React from 'react'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import {
  formatPrimaryMetalType,
  formatPrimaryDiamondShape,
  formatAdditionalDiamond,
  formatBasketType,
  formatBail,
  formatBailDiamond,
  formatHalo,
  formatHaloWidth,
  formatProngStyle,
  formatProngNumber,
  formatHandEngraving,
  formatSpecialFinish,
  formatChainMetal,
  formatChainLength,
  formatChainWidth
} from './field-formatters'

const PendantDetails = props => (
  <Grid>
    <GridItem col='1/4'>
      <DetailsItem title='Primary Metal' value={formatPrimaryMetalType(props.data)} />
      <DetailsItem title='Bail' value={formatBail(props.data)} />
      <DetailsItem title='Prong Style' value={formatProngStyle(props.data)} />
      <DetailsItem title='Chain Metal' value={formatChainMetal(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Diamond Shape' value={formatPrimaryDiamondShape(props.data)} />
      <DetailsItem title='Bail Diamonds' value={formatBailDiamond(props.data)} />
      <DetailsItem title='Prong Number' value={formatProngNumber(props.data)} />
      <DetailsItem title='Chain Length' value={formatChainLength(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Basket Type' value={formatBasketType(props.data)} />
      <DetailsItem title='Halo' value={formatHalo(props.data)} />
      <DetailsItem title='Hand Engraving' value={formatHandEngraving(props.data)} />
      <DetailsItem title='Chain Weight' value={formatChainWidth(props.data)} />
    </GridItem>
    <GridItem col='1/4'>
      <DetailsItem title='Additional Diamond(s)' value={formatAdditionalDiamond(props.data)} />
      <DetailsItem title='Row Width' value={formatHaloWidth(props.data)} />
      <DetailsItem title='Special Finish' value={formatSpecialFinish(props.data)} />
    </GridItem>
  </Grid>
)

export default PendantDetails



// WEBPACK FOOTER //
// ./src/components/jewelry-details/pendant-details.js